
import React, { Component } from 'react';
export class OurTraining extends Component {
    render() {
        require('./OurTraining.css')
        return (
            <div>
                <h2 style={{ 'text-align': 'center' }}>CONOCE NUESTROS PROCESOS</h2>
                <div class="training-container">
                    <div class="card col-md-12 row">
                        <img className="col-md-6" src="https://static.wixstatic.com/media/425d36_d060f52dcdb34e149d69f5a4c5763c03~mv2_d_6000_4000_s_4_2.jpg/v1/fill/w_938,h_762,fp_0.50_0.50,q_85,usm_0.66_1.00_0.01,enc_auto/425d36_d060f52dcdb34e149d69f5a4c5763c03~mv2_d_6000_4000_s_4_2.jpg" alt="Card Image"></img>
                        <div className="col-md-6">
                            <h3>Entrenamiento Básico</h3>
                            <p>Descubre tus barreras limitantes</p>
                            <ul>
                                <li>30 h</li>
                                <li>$695.000</li>
                            </ul>
                            <a href="/proceso-basico">Más informac&oacute;n</a>
                        </div>
                    </div>
                    <div class="card col-md-12 row">
                        <img className="col-md-6" src="https://static.wixstatic.com/media/425d36_ab17c4c30e034747b6249e055c64935c~mv2_d_4650_3100_s_4_2.jpg/v1/fill/w_938,h_762,fp_0.50_0.50,q_85,usm_0.66_1.00_0.01,enc_auto/425d36_ab17c4c30e034747b6249e055c64935c~mv2_d_4650_3100_s_4_2.jpg" alt="Card Image"></img>
                        <div className="col-md-6">
                            <h3>Entrenamiento Avanzado</h3>
                            <p>Rompe barreras limitantes y llevate al límite</p>
                            <ul>
                                <li>40 h</li>
                                <li>$850.000</li>
                            </ul>
                            <a href="/proceso-avanzado">Más informac&oacute;n</a>
                        </div>
                    </div>
                    <div class="card col-md-12 row">
                        <img className="col-md-6" src="https://static.wixstatic.com/media/425d36_621ddb43c7434783b074ab348b82693e~mv2_d_6000_3722_s_4_2.jpg/v1/fill/w_938,h_762,fp_0.50_0.50,q_85,usm_0.66_1.00_0.01,enc_auto/425d36_621ddb43c7434783b074ab348b82693e~mv2_d_6000_3722_s_4_2.jpg" alt="Card Image"></img>
                        <div className="col-md-6">
                            <h3>Programa de Liderazgo</h3>
                            <p>Resultados garantizados en tu vida, logros extraordinarios AHORA!</p>
                            <ul>
                                <li>90 h</li>
                                <li>$1.650.000</li>
                            </ul>
                            <a href="/proceso-pl">Más informac&oacute;n</a>
                        </div>

                    </div>
                </div>

                <h2 style={{ 'text-align': 'center' }}>TAMBIEN ESTAMOS CON EMPRESAS</h2>
                <div class="training-container">
                    <iframe max-width="800px" width="100%" height="515" src="https://www.youtube.com/embed/36Ql5YzwXGI?si=oiq0yg2gyzxqhxio&amp;controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
            </div>
        );
    }
}
